module.exports = __webpack_public_path__ + "media/images/offre_marque_blanche-5ac682e957a5960dcebeb804498fcbd7.pdf";